export function getQuillPlainText(html?: string): string {
  if (!html) return "";

  const div = document.createElement("div");
  div.innerHTML = html;

  return div.textContent?.replace(/\u00A0/g, "").trim() ?? "";
}

export function isQuillContentEmpty(html?: string): boolean {
  return getQuillPlainText(html).length === 0;
}
